import { render, staticRenderFns } from "./PublishReport.vue?vue&type=template&id=0672487a&scoped=true&"
import script from "./PublishReport.vue?vue&type=script&lang=js&"
export * from "./PublishReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0672487a",
  null
  
)

export default component.exports